<template>
  <el-dialog :close-on-click-modal="false" :visible.sync="visible" width="92%" append-to-body @closed="onClosed">
    <template slot="title">
      <div class="doc-dialog-header">
        <span class="doc-dialog-title">{{ dialogTitle }}</span>
        <div v-if="showViewToolbar" class="doc-dialog-actions">
          <el-button-group>
            <workflow-doc-buttons biz-type="transfer" :biz-id="form.transferId" perm="inventory:transfer" :approve-status="String(form.approveStatus || '0')" @approve="approve(true)" @unapprove="approve(false)" />
            <el-button v-if="isAuth('inventory:transfer:update')" type="primary" size="small" :disabled="!canEditDoc || actionBusy" @click="readonly = false">修改</el-button>
            <el-button v-if="isAuth('inventory:transfer:delete')" type="primary" size="small" :disabled="!canEditDoc || actionBusy" @click="remove">删除</el-button>
          </el-button-group>
        </div>
      </div>
    </template>

    <el-form ref="dataForm" :model="form" label-width="90px">
      <el-row>
        <el-col :span="6">
          <el-form-item label="调拨单号" required>
            <el-input v-model="form.transferCode" :disabled="formDisabled || codeReadonly || !!form.transferId" :placeholder="codeReadonly ? '保存时自动编号' : ''" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="日期" required>
            <el-date-picker v-model="form.transferDate" type="date" value-format="yyyy-MM-dd" style="width:100%" :disabled="formDisabled" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="备注">
            <el-input v-model="form.remark" :disabled="formDisabled" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="form.transferId">
        <el-col :span="6">
          <el-form-item label="审核状态">
            <el-tag :type="statusTagType" size="small">{{ statusText }}</el-tag>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <div v-if="inventoryBarcodeEnabled && !formDisabled" class="line-tools">
      <el-input v-model="barcodeScanCode" size="small" placeholder="扫描条码或序列号" clearable style="width:320px;" @keyup.enter.native="onBarcodeScanForLine" />
      <el-button type="primary" size="small" style="margin-left:8px;" @click="onBarcodeScanForLine">扫码加行</el-button>
    </div>
    <div class="line-tools">
      <el-button v-if="!formDisabled" type="primary" size="small" @click="addLine">新增行</el-button>
      <el-button v-if="!formDisabled" type="primary" size="small" style="margin-left:8px;" @click="materialVisible = true">选择物料</el-button>
      <el-upload v-if="!formDisabled" :show-file-list="false" action="" :http-request="doImport" accept=".xlsx" style="display:inline-block;margin-left:8px;">
        <el-button type="primary" size="small">导入(产品编码)</el-button>
      </el-upload>
      <el-button v-if="!formDisabled" size="small" style="margin-left:8px;" @click="downloadTemplate">下载导入模板</el-button>
      <el-button v-if="!formDisabled" size="small" style="margin-left:8px;" @click="fillDefaultWarehouses">按默认仓库补调出库位</el-button>
      <el-button v-if="!formDisabled" size="small" style="margin-left:8px;" @click="clearWarehouses">清空库位</el-button>
    </div>

    <el-table border :data="form.lines" :header-cell-style="{ background: '#f5f7fa', color: '#606266' }">
      <el-table-column type="index" label="序号" header-align="center" align="center" width="60" />
      <el-table-column label="产品编码" header-align="center" min-width="140">
        <template slot-scope="scope">
          <el-input v-model="scope.row.materialCode" :disabled="formDisabled" placeholder="输入产品编码" @blur="fillLine(scope.row)" />
        </template>
      </el-table-column>
      <el-table-column prop="materialName" label="产品名称" header-align="center" min-width="140" />
      <el-table-column prop="customerCode" label="客户编码" header-align="center" min-width="120" />
      <el-table-column prop="specs" label="规格型号" header-align="center" min-width="120" />
      <el-table-column v-if="inventoryBarcodeEnabled" label="序列号" header-align="center" min-width="280">
        <template slot-scope="scope">
          <inventory-line-serial-panel v-if="isSerialMaterial(scope.row)" :value="scope.row.serialNos" :expected-qty="serialExpectedQty(scope.row)" :readonly="formDisabled" @input="v => $set(scope.row, 'serialNos', v)" />
          <span v-else style="color:#909399;">—</span>
        </template>
      </el-table-column>
      <el-table-column label="数量" header-align="center" width="160">
        <template slot-scope="scope">
          <el-input-number v-model="scope.row.quantity" :disabled="formDisabled" :min="0" :precision="2" style="width:100%" />
        </template>
      </el-table-column>
      <el-table-column label="调出库位" header-align="center" min-width="220">
        <template slot-scope="scope"><warehouse-location-select v-model="scope.row.fromWareHouseId" :disabled="formDisabled" /></template>
      </el-table-column>
      <el-table-column label="调入库位" header-align="center" min-width="220">
        <template slot-scope="scope"><warehouse-location-select v-model="scope.row.toWareHouseId" :disabled="formDisabled" /></template>
      </el-table-column>
      <el-table-column v-if="!formDisabled" fixed="right" label="操作" width="70" header-align="center" align="center">
        <template slot-scope="scope"><el-button type="text" size="small" @click="form.lines.splice(scope.$index, 1)">删除</el-button></template>
      </el-table-column>
    </el-table>

    <span slot="footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button v-if="!formDisabled" type="primary" :loading="saving" @click="save">确定</el-button>
    </span>

    <material-selector :visible.sync="materialVisible" multiple @select-multiple="chooseMaterials" />
  </el-dialog>
</template>

<script>
import WorkflowDocButtons from '../../components/WorkflowDocButtons.vue'
import request from '../../api/request'
import { fetchPerms } from '../../api/auth'
import WarehouseLocationSelect from '../../components/WarehouseLocationSelect.vue'
import MaterialSelector from '../../components/MaterialSelector.vue'
import InventoryLineSerialPanel from '../../components/InventoryLineSerialPanel.vue'
import { getMaterialByCode } from '../../api/base/material'
import { today, fillMaterialRow, downloadInventoryTemplate, importInventoryLines, showImportError, postDoc, mergeQtyLines, transferLineKey } from './inventoryShared'
import inventoryBarcodeMixin from '../../mixins/inventory-barcode'
import { workflowStatusText, workflowStatusTagType } from '../../utils/workflow'

export default {
  name: 'TransferAddOrUpdate',
  components: { WorkflowDocButtons, WarehouseLocationSelect, MaterialSelector, InventoryLineSerialPanel },
  mixins: [inventoryBarcodeMixin],
  data() {
    return {
      kind: 'transfer',
      visible: false,
      readonly: false,
      saving: false,
      actionBusy: false,
      codeReadonly: false,
      materialVisible: false,
      permCodes: [],
      form: this.blank()
    }
  },
  computed: {
    formDisabled() {
      const wf = this.form.workflowStatus
      return this.readonly || String(this.form.approveStatus) === '2' || !!(wf && wf !== 'draft' && wf !== 'rejected')
    },
    canEditDoc() {
      const wf = this.form.workflowStatus
      return String(this.form.approveStatus) !== '2' && (!wf || wf === 'draft' || wf === 'rejected')
    },
    showViewToolbar() { return this.readonly && !!this.form.transferId },
    dialogTitle() {
      if (this.readonly || String(this.form.approveStatus) === '2') return '查看调拨单'
      return this.form.transferId ? '修改调拨单' : '新增调拨单'
    },
    statusText() { return workflowStatusText(this.form.workflowStatus, this.form.approveStatus) },
    statusTagType() { return workflowStatusTagType(this.form.workflowStatus, this.form.approveStatus) }
  },
  created() {
    this.loadPerms()
    this.loadInventoryBarcodePolicy()
  },
  methods: {
    isAuth(perm) {
      const user = this.$store.state.user || {}
      const codes = Array.isArray(user.roleCodes) ? user.roleCodes : []
      const role = String(user.roleCode || '')
      if (role === 'TENANT_ADMIN' || role === 'PLATFORM_ADMIN' || codes.indexOf('TENANT_ADMIN') >= 0 || codes.indexOf('PLATFORM_ADMIN') >= 0) return true
      return this.permCodes.indexOf(perm) >= 0
    },
    loadPerms() {
      fetchPerms().then(res => { this.permCodes = res.data || [] }).catch(() => {})
    },
    blank() {
      return { transferId: '', transferCode: '', transferDate: today(), remark: '', approveStatus: '0', workflowStatus: '', lines: [] }
    },
    init(id, readonly) {
      this.visible = true
      this.readonly = !!readonly
      this.codeReadonly = false
      this.actionBusy = false
      this.form = this.blank()
      if (!id) { this.resolveCode(); return }
      request.get('/inventory/transfer/info/' + id).then(res => {
        const data = res.data || {}
        this.form = Object.assign(this.blank(), data, {
          lines: data.lines || [],
          approveStatus: data.approveStatus != null ? String(data.approveStatus) : '0'
        })
      }).catch(() => {})
    },
    onClosed() {
      this.form = this.blank()
      this.readonly = false
    },
    resolveCode() {
      request.post('/base/docNumberRule/resolve', { docType: 'transfer' }).then(res => {
        const data = res.data || {}
        this.codeReadonly = !!data.codeReadonly
        if (this.codeReadonly && data.previewCode) this.form.transferCode = data.previewCode
      }).catch(() => {})
    },
    addLine() {
      this.form.lines.push({
        materialCode: '', materialName: '', customerCode: '', specs: '', quantity: 0,
        wareHouseId: '', fromWareHouseId: '', toWareHouseId: '', batchNo: '', supplierName: '', remark: ''
      })
    },
    fillLine(row) {
      fillMaterialRow(row).then(m => { if (m === null) this.$message.warning('未找到该产品编码') }).catch(() => {})
    },
    chooseMaterials(materials) {
      (materials || []).forEach(m => {
        const hit = this.form.lines.find(item => item.materialCode === m.materialCode)
        if (hit) { hit.quantity = Number((Number(hit.quantity || 0) + 1).toFixed(2)); return }
        this.form.lines.push({
          materialId: m.materialId, materialCode: m.materialCode, materialName: m.materialName,
          customerCode: m.customerCode || '', specs: m.specs || '', quantity: 1,
          wareHouseId: '', fromWareHouseId: '', toWareHouseId: '', batchNo: '', supplierName: '', remark: ''
        })
      })
    },
    downloadTemplate() { downloadInventoryTemplate('transfer', '调拨导入模板.xlsx').catch(() => this.$message.error('模板下载失败')) },
    doImport(req) {
      importInventoryLines('transfer', req.file).then(lines => {
        lines.forEach(item => {
          this.form.lines.push({
            materialId: item.materialId, materialCode: item.materialCode, materialName: item.materialName || '',
            customerCode: item.customerCode || '', specs: item.specs || '', quantity: item.quantity,
            fromWareHouseId: item.fromWareHouseId || '', toWareHouseId: item.toWareHouseId || '', batchNo: item.batchNo || '', remark: ''
          })
        })
        this.$message.success('导入成功')
      }).catch(e => showImportError(this, e))
    },
    fillDefaultWarehouses() {
      const lines = (this.form.lines || []).filter(line => (line.materialCode || '').trim() && !line.fromWareHouseId)
      const tasks = lines.map(line => getMaterialByCode(line.materialCode.trim()).then(res => {
        const id = res.data && res.data.wareHouseId
        if (!id) return false
        line.fromWareHouseId = id
        return true
      }).catch(() => false))
      if (!tasks.length) { this.$message.info('没有可填充的空调出库位'); return }
      Promise.all(tasks).then(results => {
        if (results.some(Boolean)) this.$message.success('已按物料默认仓库填充调出库位；请另选调入库位')
        else this.$message.info('物料未配置默认仓库，请手动选择调出库位')
      })
    },
    clearWarehouses() {
      ;(this.form.lines || []).forEach(line => {
        line.fromWareHouseId = ''
        line.toWareHouseId = ''
      })
      this.$message.success('已清空明细库位')
    },
    save() {
      if (!this.codeReadonly && !(this.form.transferCode || '').trim()) { this.$message.error('调拨单号不能为空'); return }
      if (!this.form.transferDate) { this.$message.error('日期不能为空'); return }
      const merged = mergeQtyLines(this.form.lines, transferLineKey)
      this.form.lines = merged.lines
      if (merged.hadDuplicate) this.$message.warning('检测到重复明细，已自动合并后再保存')
      if (!this.form.lines.length) { this.$message.error('请至少维护一条明细'); return }
      for (let i = 0; i < this.form.lines.length; i++) {
        const line = this.form.lines[i]
        const rowNo = i + 1
        if (Number(line.quantity) <= 0) { this.$message.error(`第${rowNo}行：调拨数量必须大于0`); return }
        if (!line.fromWareHouseId) { this.$message.error(`第${rowNo}行：请选择调出库位`); return }
        if (!line.toWareHouseId) { this.$message.error(`第${rowNo}行：请选择调入库位`); return }
        if (line.fromWareHouseId === line.toWareHouseId) { this.$message.error(`第${rowNo}行：调出库位和调入库位不能相同`); return }
      }
      const id = this.form.transferId
      const body = {
        id, code: this.form.transferCode, bizDate: this.form.transferDate,
        transferId: id, transferCode: this.form.transferCode, transferDate: this.form.transferDate,
        remark: this.form.remark, lines: this.form.lines
      }
      this.saving = true
      postDoc('transfer', body, id).then(() => {
        this.$message.success('操作成功')
        this.visible = false
        this.$emit('refreshDataList')
      }).catch(() => {}).finally(() => { this.saving = false })
    },
    approve(pass) {
      const id = this.form.transferId
      this.$confirm(pass ? '审核后将更新库存现存量，是否继续?' : '弃审将冲回对应库存，是否继续?', '提示', { type: 'warning' }).then(() => {
        this.actionBusy = true
        request.post('/inventory/transfer/' + (pass ? 'approve' : 'unapprove'), { id }).then(() => {
          this.$message.success('操作成功')
          this.visible = false
          this.$emit('refreshDataList')
        }).catch(() => {}).finally(() => { this.actionBusy = false })
      }).catch(() => {})
    },
    remove() {
      this.$confirm('确定删除该单据?', '提示', { type: 'warning' }).then(() => {
        this.actionBusy = true
        request.post('/inventory/transfer/delete', { id: this.form.transferId }).then(() => {
          this.$message.success('操作成功')
          this.visible = false
          this.$emit('refreshDataList')
        }).catch(() => {}).finally(() => { this.actionBusy = false })
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.doc-dialog-header { display: flex; align-items: center; justify-content: space-between; padding-right: 28px; }
.doc-dialog-title { font-size: 16px; font-weight: 600; }
.doc-dialog-actions .el-button { margin-left: 0; }
.line-tools { margin-bottom: 10px; }
</style>
